import { render, staticRenderFns } from "./ImageArea.vue?vue&type=template&id=318f43e4"
import script from "./ImageArea.vue?vue&type=script&lang=js"
export * from "./ImageArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports